import React from 'react'
import type { PaymentRecord } from '../types/app'
import { disputeTag, paymentDetail, paymentTitle, refundLine } from '../payments/history'
import './PaymentHistory.css'

interface PaymentHistoryProps {
  payments: PaymentRecord[]
  // Whether a payment offers Refund here (a Stripe one needs card payments
  // shown); onRefund opens the sheet for it.
  canRefund: (p: PaymentRecord) => boolean
  onRefund: (p: PaymentRecord) => void
}

// PaymentHistory lists every payment taken, with Stripe's fee and each refund
// made against it, oldest first, so the money on one appointment or package
// can be followed from start to end.
export default function PaymentHistory({ payments, canRefund, onRefund }: PaymentHistoryProps) {
  const labelId = React.useId()
  if (payments.length === 0) return null
  return (
    <section className="payment-history-block" aria-labelledby={labelId}>
      <span id={labelId} className="detail-label">
        Payments
      </span>
      <ul className="payment-history">
        {payments.map((p) => (
          <li key={p.id} className="payment-history__item">
            <span className="payment-history__title">{paymentTitle(p)}</span>
            {disputeTag(p) && <span className={disputeTag(p)!.tone === 'danger' ? 'tag tag--danger' : 'tag'}>{disputeTag(p)!.text}</span>}
            {canRefund(p) && (
              <button type="button" className="btn btn-danger btn-compact" onClick={() => onRefund(p)}>
                Refund
              </button>
            )}
            <p className="payment-history__line">{paymentDetail(p)}</p>
            {p.refunds.map((r) => (
              <p key={r.id} className="payment-history__line">
                {refundLine(r)}
              </p>
            ))}
          </li>
        ))}
      </ul>
    </section>
  )
}
